import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login/Login";
import SignUp from "../pages/SignUp/SignUp";
import ProtectedRoute from "./ProtectedRoute";
import UnAuthorized from "../pages/UnAuthorized/UnAuthorized";
import useAutoLogout from "../hooks/useAutoLogout";

// Admin
import AdminDashBoard from "../pages/Admin/DashBoard/AdminDashBoard";
import AllProjects from "../pages/Admin/Projects/AllProjects/AllProjects";
import CreateProject from "../pages/Admin/Projects/CreateProject/CreateProject";
import UpdateProject from "../pages/Admin/Projects/UpdateProject/UpdateProject";
import ProjectFullView from "../components/ProjectFullView/ProjectFullView";
import AllTasks from "../pages/Admin/Tasks/AllTasks/AllTasks";
import TaskFullView from '../components/TaskFullView/TaskFullView';
import CreateTask from "../pages/Admin/Tasks/CreateTask/CreateTask";
import UpdateTask from "../pages/Admin/Tasks/UpdateTask/UpdateTask";
import AllUsers from "../pages/Admin/Users/AllUsers/AllUsers";
import AllPayroll from "../pages/Admin/Payroll/AllPayRoll/AllPayRoll";
import CreatePayroll from "../pages/Admin/Payroll/CreatePayroll/createPayroll";
import UpdatePayroll from "../pages/Admin/Payroll/UpdatePayroll/UpdatePayroll";
import AdminInfo from "../pages/Admin/Settings/AdminInfo/AdminInfo";
import UserFullView from "../pages/Admin/Users/UserFullView/userFullView";
import Settings from "../pages/Admin/Settings/Settings";

// Employee
import EmployeeDashBoard from "../pages/Employees/DashBoard/EmployeeDashBoard";
import EmployeeProjects from "../pages/Employees/Projects/AllProjects/EmployeeProjects";
import EmployeeProjectFullView from "../pages/Employees/Projects/ProjectFullView/EmployeeProjectFullView";
import EmployeeAllTasks from "../pages/Employees/Tasks/AllTasks/EmployeeTasks";
import EmployeeTaskDetails from "../pages/Employees/Tasks/TaskFullView/EmployeeTaskFullView";
import EmployeeInfo from "../pages/Employees/EmployeeInfo/EmployeeInfo";
import EmployeeSetting from "../pages/Employees/Settings/EmployeeSettings";

// Common
import TermsAndConditions from "../pages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";

export default function AppRoutes() {
    useAutoLogout();

    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />

            {/* ✅ All Admin Routes Wrapped in ProtectedRoute */}
            <Route
                path="/admin-dashboard/:employeeId/*"
                element={
                    <ProtectedRoute allowedRoles={["Admin", "HR", "Manager"]}>
                        <Routes>
                            <Route path="" element={<AdminDashBoard />} />
                            <Route path="all-projects" element={<AllProjects />} />
                            <Route path="create-project" element={<CreateProject />} />
                            <Route path="update-project/:projectId" element={<UpdateProject />} />
                            <Route path="projects/:projectId" element={<ProjectFullView />} />
                            <Route path="all-tasks" element={<AllTasks />} />
                            <Route path="all-tasks/create-task" element={<CreateTask />} />
                            <Route path="all-tasks/:taskId" element={<TaskFullView />} />
                            <Route path="update-task/:taskId" element={<UpdateTask />} />
                            <Route path="all-users" element={<AllUsers />} />
                            <Route path="users/:employeeId" element={<UserFullView />} />
                            <Route path="all-payrolls" element={<AllPayroll />} />
                            <Route path="payroll/create-payroll/:employeeId" element={<CreatePayroll />} />
                            <Route path="payroll/update-payroll/:employeeId" element={<UpdatePayroll />} />
                            <Route path="info" element={<AdminInfo />} />
                            <Route path="settings" element={<Settings />} />
                            <Route path="*" element={<UnAuthorized />} />
                        </Routes>
                    </ProtectedRoute>
                }
            />

            {/* ✅ All Employee Routes Wrapped in ProtectedRoute */}
            <Route
                path="/employee-dashboard/:employeeId/*"
                element={
                    <ProtectedRoute allowedRoles={["Employee"]}>
                        <Routes>
                            <Route path="" element={<EmployeeDashBoard />} />
                            <Route path="all-projects" element={<EmployeeProjects />} />
                            <Route path="projects/:projectId" element={<EmployeeProjectFullView />} />
                            <Route path="all-tasks" element={<EmployeeAllTasks />} />
                            <Route path="all-tasks/:taskId" element={<EmployeeTaskDetails />} />
                            <Route path="settings" element={<EmployeeSetting />} />
                            <Route path="info" element={<EmployeeInfo />} />
                            <Route path="*" element={<UnAuthorized />} />
                        </Routes>
                    </ProtectedRoute>
                }
            />

            {/* Public Info Pages */}
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Fallback */}
            <Route path="*" element={<UnAuthorized />} />
        </Routes>
    );
}
